/** @format */
import React, { FunctionComponent } from 'react';

import { CustomSelectSkeleton } from '@toucan/client/features/search/components/search-filter/components/custom-select/skeleton';

import { SearchFilterSkeletonProps } from './types';

export const SearchFilterSkeleton: FunctionComponent<
    SearchFilterSkeletonProps
> = (props) => <CustomSelectSkeleton {...props} />;
